import {Button, Form} from "react-bootstrap";
import emailjs from '@emailjs/browser';
import {useState} from "react";


const Contact = () => {

    const [formData, setFormData] = useState({});

    const handleChangeInput = (event) => {
        setFormData({...formData,  [event.target.name]: event.target.value});
    }

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_h8tzq13', 'template_sg9rtsf', "#contactForm", {
                publicKey: 'rGQvZ_uQS2udYOUo2',
            })
            .then(
                () => {
                    alert("Email Sent! Dave will get back to you within 72 hours.")
                },
                (error) => {
                    alert("Email Failed to Send! Please call Dave instead.")
                },
            );
    };

    return (
        <div className={"contact-container"}>
            <h1>Contact</h1>
            <hr />
            <Form id={"contactForm"} name={"contactForm"} onSubmit={sendEmail}>
                <Form.Group controlId="name" onChange={handleChangeInput}>
                    <Form.Label column={"sm"}>Your Name</Form.Label>
                    <Form.Control name={"name"} type="text" placeholder="Enter name" />
                </Form.Group>

                <Form.Group controlId="email" onChange={handleChangeInput}>
                    <Form.Label column={"sm"}>Your Email address</Form.Label>
                    <Form.Control name={"email"} type="email" placeholder="Enter email" />
                    <Form.Text className="text-muted">
                        We'll never share your email with anyone else.
                    </Form.Text>
                </Form.Group>

                <Form.Group controlId="subject" onChange={handleChangeInput}>
                    <Form.Label column={"sm"}>Subject</Form.Label>
                    <Form.Control name={"subject"} type="text" placeholder="Enter Email subject" />
                </Form.Group>

                <Form.Group controlId="message" onChange={handleChangeInput}>
                    <Form.Label column={"sm"}>Query</Form.Label>
                    <Form.Control name={"message"} as="textarea" rows={3} placeholder="Describe your request or question" />
                </Form.Group>

                <Button variant="primary" type="submit">
                    Send Email
                </Button>
            </Form>
            <hr />
            <div className={"phone"}>
                Want to talk? Call me at (480) 372-0601
            </div>
        </div>
    )

}; export default Contact;